import React, { Suspense } from 'react';
import { Header } from './components/Header';
import { Configurator } from './components/Configurator';
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Typography } from '@material-ui/core';
var LazyReadme = React.lazy(function () {
    return import('./components/Readme' /* webpackChunkName: 'Readme' */).then(function (_a) {
        var Readme = _a.Readme;
        return ({ default: Readme });
    });
});
var LazyCliReadme = React.lazy(function () {
    return import('./components/CliReadme' /* webpackChunkName: 'CliReadme' */).then(function (_a) {
        var CliReadme = _a.CliReadme;
        return ({
            default: CliReadme,
        });
    });
});
export var App = function () { return (React.createElement(React.Fragment, null,
    React.createElement(Header, null),
    React.createElement(ExpansionPanel, null,
        React.createElement(ExpansionPanelSummary, null,
            React.createElement(Typography, null, "Readme")),
        React.createElement(ExpansionPanelDetails, null,
            React.createElement(Suspense, { fallback: 'Loading Readme' },
                React.createElement(LazyReadme, null)))),
    React.createElement(ExpansionPanel, { defaultExpanded: true },
        React.createElement(ExpansionPanelSummary, null,
            React.createElement(Typography, null, "Configurator")),
        React.createElement(ExpansionPanelDetails, null,
            React.createElement(Configurator, null))),
    React.createElement(ExpansionPanel, null,
        React.createElement(ExpansionPanelSummary, null,
            React.createElement(Typography, null, "Cli")),
        React.createElement(ExpansionPanelDetails, null,
            React.createElement(Suspense, { fallback: 'Loading Readme' },
                React.createElement(LazyCliReadme, null)))))); };
